import React from 'react';
import { UIHeading2, UIText1 } from '@cian/ui-kit';

import { ISidebarCardParams, SidebarCard } from '../SidebarCard';
import * as s from './SidebarAddPostTip.css';

interface ISidebarAddPostTip {
  title: string;
  text: string;
  theme?: ISidebarCardParams['theme'];
}

/**
 * Список советов для создания поста в сайдбаре
 */
export const SidebarAddPostTip = ({ title, text, theme }: ISidebarAddPostTip) => (
  <SidebarCard theme={theme}>
    <div className={s['wrapper']}>
      <UIHeading2>{title}</UIHeading2>
      <UIText1>{text}</UIText1>
    </div>
  </SidebarCard>
);
